export default __webpack_public_path__ + "static/media/fb_help3.e32fbb62.svg";